export default "__VITE_ASSET__PFBH5AZf__"